import React, { CSSProperties } from 'react';

//Use to pass 'Modal' information down from the workspace.
//Would eventually like to move the current Modal management so having everything work via this will help.
const ModalContext = React.createContext({} as IModalContext);
export default ModalContext;

//TODO - Revise - invoiceQueryVariables/returnInvoice/refundInvoice/manageLines - Likely better placed on another Context.
export type IModalContext = {
  invoiceQueryVariables?: object;
  returnInvoice?: (invoice: any) => void;
  refundInvoice?: (invoice: any) => void;
  manageLines?: (invoice: any) => void;
  onClose?: (values?: any) => void;
  style?: any; //Style object, should match the one used for the modal (This is used for re-sizing elements that are nested inside the modal, such as editableDataGrids).
  tabStyles?: {
    container: CSSProperties;
  };
};
